import {variants as TableVariants} from './Table.styles';
import {baseStyles as ButtonBaseStyles} from './Button.styles';
import {baseStyles as TabsBaseStyles} from './Tabs.styles';
import multiSelectTheme from './multiselect.styles';

const theme = {
    breakpoints: {
        navigation: '75rem', // 1200px
    },
    colors: {
        navBlue: '#e9f0f9',
    },
    components: {
        Button: {
            baseStyle: ButtonBaseStyles,
        },
        Drawer: {
            sizes: {
                sidebar: {
                    dialog: {
                        // The subtraction of 1px allows for the Drawer to retain the border from the FacilitySidebar container
                        maxWidth: 'calc(21.875rem - 1px)',
                    },
                },
            },
        },
        Table: {
            variants: TableVariants,
        },
        Tabs: {
            baseStyle: TabsBaseStyles,
        },
        MultiSelect: multiSelectTheme,
    },
    fonts: {
        body: `"Plus Jakarta Sans Variable", sans-serif`,
        heading: `"Plus Jakarta Sans Variable", sans-serif`,
    },
};

export default theme;
